import React, {Suspense} from 'react';
import PageLoading from './components/pageLoading';

const Platform = React.lazy(() => import('./pages/Platform'));

export default ({history, app}) => {
    return (
        <Suspense fallback={<PageLoading/>}>
            <Platform/>
        </Suspense>
    )
}